import { ChevronDown, ChevronRight } from "lucide-react";

import {
  DateField,
  Field,
  REPORT_GENDER_OPTIONS,
  SelectField,
  TextInput,
} from "./fields";
import styles from "./ReportsFilters.module.css";
import { useAdvancedToggle } from "./useAdvancedToggle";

export const CdmRecallFilters = ({ filters, onFilterChange }) => {
  const { showAdvanced, toggleAdvanced } = useAdvancedToggle();
  const advancedActiveCount = [
    filters.patientFirstname,
    filters.patientLastname,
    filters.gender,
  ].filter(Boolean).length;

  return (
    <div className={styles.finderLayout}>
      <div className={styles.recallGrid}>
        <DateField
          label="Due from"
          value={filters.dueByFrom}
          onChange={(v) => onFilterChange("dueByFrom", v)}
          placeholder="From date"
        />
        <DateField
          label="Due to"
          value={filters.dueByTo}
          onChange={(v) => onFilterChange("dueByTo", v)}
          placeholder="To date"
        />
        <SelectField
          label="Programme"
          options={[
            { value: "", label: "All programmes" },
            { value: "CDM", label: "Chronic Disease Management" },
            { value: "PP", label: "Prevention Programme" },
          ]}
          value={filters.programme}
          onChange={(v) => onFilterChange("programme", v)}
        />
        <SelectField
          label="Review type"
          options={[
            { value: "", label: "Any review type" },
            { value: "Registration", label: "Registration" },
            { value: "Annual", label: "Annual" },
            { value: "Interim", label: "Interim" },
          ]}
          value={filters.reviewType}
          onChange={(v) => onFilterChange("reviewType", v)}
        />
      </div>

      <div className={styles.finderAdvancedSection}>
        <button
          type="button"
          className={styles.finderAdvancedToggle}
          onClick={toggleAdvanced}
          aria-expanded={showAdvanced}
        >
          {showAdvanced ? (
            <ChevronDown size={16} aria-hidden />
          ) : (
            <ChevronRight size={16} aria-hidden />
          )}
          <span>Advanced filters</span>
          {!showAdvanced && advancedActiveCount > 0 && (
            <span className={styles.finderAdvancedBadge}>
              {advancedActiveCount}
            </span>
          )}
        </button>

        {!!showAdvanced && (
          <div className={styles.finderAdvanced}>
            <div className={styles.recallGrid}>
              <Field label="First Name">
                <TextInput
                  value={filters.patientFirstname}
                  onChange={(v) => onFilterChange("patientFirstname", v)}
                  placeholder="First name"
                />
              </Field>
              <Field label="Last Name">
                <TextInput
                  value={filters.patientLastname}
                  onChange={(v) => onFilterChange("patientLastname", v)}
                  placeholder="Last name"
                />
              </Field>
              <SelectField
                label="Gender"
                options={REPORT_GENDER_OPTIONS}
                value={filters.gender}
                onChange={(v) => onFilterChange("gender", v)}
              />
            </div>
          </div>
        )}
      </div>

      <div className={styles.finderNote}>
        <p style={{ margin: "0 0 12px", fontWeight: 600 }}>
          CDM Recall — patients due for their next review.
        </p>
        <p style={{ margin: 0 }}>
          Lists patients enrolled on a CDM / Prevention Programme whose next
          review falls due. Set a due-date range and, optionally, a programme
          and review type to build your recall list.
        </p>
      </div>
    </div>
  );
};
